import { ITertiaryNavItems } from 'types/secondaryNavbar.types';
import { Dictionary } from 'types/utils.types';

export const DYNAMIC_ROUTES_CONSTANT = {
  INTERVIEW_SLUG: ':interviewSlug',
  REPORT_SLUG: ':reportSlug',
  SSO_ACCESS_CODE: ':ssoAccessCode',
  COMPANY_SLUG: ':companySlug',
  CAMPAIGN_SLUG: ':campaignSlug',
  QUESTION_SLUG: ':questionSlug',
};

export const RELATIVE_ROUTES = {
  ROOT: '/',
  INTERVIEWS: '/recruit/interviews',
  DHWANI: '/recruit/cocaller',
  RECRUIT: '/recruit/',
  INTERVIEW: '/interview/',
  AI_INTERVIEW: 'ai',
  MANUAL_INTERVIEW: 'manual',
  PUBLIC: '/public/',
  SSO_ROUTE: '/sso/',
  TEAM_SETTINGS: '/settings/team/',
  BACKOFFICE: '/bo/',
  BILLING: '/billing',
};

export const ROUTES = {
  MANUAL_INTERVIEW_ROUTE: '/recruit/interviews/manual',
  AI_INTERVIEW_ROUTE: '/recruit/interviews/ai',
  INTERVIEW_ROUTE: `/interview/${DYNAMIC_ROUTES_CONSTANT.INTERVIEW_SLUG}`,
  INTERVIEW_EVALUATION_CRITERIA_ROUTE: `/interview/${DYNAMIC_ROUTES_CONSTANT.INTERVIEW_SLUG}/evaluation-criteria`,
  INTERVIEW_SETTINGS_ROUTE: `/interview/${DYNAMIC_ROUTES_CONSTANT.INTERVIEW_SLUG}/settings`,
  INTERVIEW_MANAGER_ROUTE: `/interview/${DYNAMIC_ROUTES_CONSTANT.INTERVIEW_SLUG}/interview-manager`,
  SCHEDULE_INTERVIEW_ROUTE: `/interview/${DYNAMIC_ROUTES_CONSTANT.INTERVIEW_SLUG}/schedule-interview`,
  EDIT_SCHEDULE_INTERVIEW_ROUTE: `/interview/${DYNAMIC_ROUTES_CONSTANT.INTERVIEW_SLUG}/schedule-interview/${DYNAMIC_ROUTES_CONSTANT.REPORT_SLUG}/edit`,
  CANDIDATE_REPORT_ROUTE: `/interview/${DYNAMIC_ROUTES_CONSTANT.INTERVIEW_SLUG}/report/${DYNAMIC_ROUTES_CONSTANT.REPORT_SLUG}`,
  PROBLEM_LIBRARY: `/interview/${DYNAMIC_ROUTES_CONSTANT.INTERVIEW_SLUG}/library`,
  TEAM_SETTINGS_ROLES_ROUTE: '/settings/team/roles',
  BACKOFFICE_ROLES_ROUTE: `/bo/company/${DYNAMIC_ROUTES_CONSTANT.COMPANY_SLUG}/roles`,
  DHWANI_CAMPAIGN_ROUTE: `/cocaller/campaign/${DYNAMIC_ROUTES_CONSTANT.CAMPAIGN_SLUG}`,
  DHWANI_CAMPAIGN_CREATE_ROUTE: `/cocaller/campaign/create`,
  DHWANI_CAMPAIGN_DETAILS_ROUTE: `/cocaller/campaign/${DYNAMIC_ROUTES_CONSTANT.CAMPAIGN_SLUG}/campaign-details`,
  DHWANI_CAMPAIGN_QUESTIONS_ROUTE: `/cocaller/campaign/${DYNAMIC_ROUTES_CONSTANT.CAMPAIGN_SLUG}/questions`,
  DHWANI_CREATE_CAMPAIGN_QUESTION_ROUTE: `/cocaller/campaign/${DYNAMIC_ROUTES_CONSTANT.CAMPAIGN_SLUG}/create-question`,
  DHWANI_CAMPAIGN_QUESTION_ROUTE: `/cocaller/campaign/${DYNAMIC_ROUTES_CONSTANT.CAMPAIGN_SLUG}/question/${DYNAMIC_ROUTES_CONSTANT.QUESTION_SLUG}`,
  DHWANI_CAMPAIGN_CANDIDATE_DETAILS_ROUTE: `/cocaller/campaign/${DYNAMIC_ROUTES_CONSTANT.CAMPAIGN_SLUG}/candidate-details`,
  DHWANI_CAMPAIGN_LAUNCH_ROUTE: `/cocaller/campaign/${DYNAMIC_ROUTES_CONSTANT.CAMPAIGN_SLUG}/launch-campaign`,
  CREATE_AI_INTERVIEW_ROUTE: `${RELATIVE_ROUTES.RECRUIT}assistant/interview`,
  BASE_ROUTE: '/',
  STAR_ROUTE: '*',
};

export const DHWANI_ROUTES = [
  RELATIVE_ROUTES.DHWANI,
  ROUTES.DHWANI_CAMPAIGN_CREATE_ROUTE,
  ROUTES.DHWANI_CAMPAIGN_DETAILS_ROUTE,
  ROUTES.DHWANI_CAMPAIGN_QUESTIONS_ROUTE,
  ROUTES.DHWANI_CAMPAIGN_QUESTION_ROUTE,
  ROUTES.DHWANI_CREATE_CAMPAIGN_QUESTION_ROUTE,
  ROUTES.DHWANI_CAMPAIGN_CANDIDATE_DETAILS_ROUTE,
  ROUTES.DHWANI_CAMPAIGN_LAUNCH_ROUTE,
];

export const INTERVIEW_ROUTES = [
  RELATIVE_ROUTES.INTERVIEWS,
  ROUTES.INTERVIEW_ROUTE,
  ROUTES.MANUAL_INTERVIEW_ROUTE,
  ROUTES.INTERVIEW_EVALUATION_CRITERIA_ROUTE,
  ROUTES.INTERVIEW_SETTINGS_ROUTE,
  ROUTES.INTERVIEW_MANAGER_ROUTE,
  ROUTES.SCHEDULE_INTERVIEW_ROUTE,
  ROUTES.EDIT_SCHEDULE_INTERVIEW_ROUTE,
  ROUTES.CANDIDATE_REPORT_ROUTE,
  ROUTES.PROBLEM_LIBRARY,
];

export const AI_INTERVIEW_ROUTE = [ROUTES.AI_INTERVIEW_ROUTE];

export const INTERVIEW_NAV_META: Dictionary<ITertiaryNavItems> = {
  INTERVIEW: {
    id: 'interviews-manual',
    name: 'Manual Interview',
    path: '/recruit/interviews/manual',
  },
  'AI INTERVIEW': {
    id: 'interviews-ai',
    name: 'AI Interview',
    path: '/recruit/interviews/ai',
  },
};
